<template>
  <div id="app">
    <router-view />
    <app-footer />
  </div>
</template>

<script>
import AppFooter from "@/components/AppFooter.vue";
export default {
  name: "App",
  components: { AppFooter },
};
</script>

<style>
/* 全局样式 */
body,
html {
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
}
</style>
